<mat-card appearance="outlined" color="primary" data-tfa="mat-card-not-found">
  <mat-card-header>
    <mat-card-title data-tfa="mat-card-not-found-title">
      <h1>{{ title }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <h2 class="not-found" data-tfa="404">404</h2>
    <a
      mat-raised-button
      color="primary"
      [routerLink]="['/']"
      data-tfa="mat-raised-btn-link-back-to-home"
      i18n="Bouton|Retour à la page d'accueil@@PIECES-BACK-TO-HOME"
    >
      PIECES-BACK-TO-HOME
    </a>
  </mat-card-content>
</mat-card>
